module.exports = __webpack_public_path__ + "img/p4-en.66cc7982.png";